import { isPlatformBrowser } from '@angular/common';
import { environment } from '../environments/environment';
import { ConfigService } from './services/config/config.service';

export function appInitializerFactory(cfg: ConfigService, platformId: object) {
  return () => {
    // Each brand has its own build, so its environment carries the brand config.
    const config = environment.brandConfig;
    cfg.set(config);

    if (isPlatformBrowser(platformId)) {
      if (config.favicon) {
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = config.favicon;
        document.head.appendChild(link);
      }

      if (config.themeCss) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = config.themeCss;
        document.head.appendChild(link);
      }
    }
  };
}
